var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 170,
    viewBox: "0 0 65 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_3780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 -1.83366e-06L65 0L54.5127 10.4873L44.0254 -1.83366e-06Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 35.5391L65 35.5391L54.5127 46.0264L44.0254 35.5391Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 71.0937L65 71.0938L54.5127 81.581L44.0254 71.0937Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 106.633L65 106.633L54.5127 117.12L44.0254 106.633Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 142.168L65 142.168L54.5127 152.67L44.0254 142.168Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 17.2773L20.9746 17.2773L10.4873 27.7646L1.90735e-05 17.2773Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 52.832L20.9746 52.832L10.4873 63.3193L1.90735e-05 52.832Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 88.3711L20.9746 88.3711L10.4873 98.8584L1.90735e-05 88.3711Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 123.91L20.9746 123.91L10.4873 134.397L1.90735e-05 123.91Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 159.461L20.9746 159.461L10.4873 169.948L1.90735e-05 159.461Z",
    fill: "#0593A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_3780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 169.949,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 65 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDownArrow);
export default __webpack_public_path__ + "static/media/bg_down_arrow.c2fc0956af293653de7b1ab0d92b7243.svg";
export { ForwardRef as ReactComponent };